var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { log } from "@ledgerhq/logs";
import { addTokens, convertERC20 } from "@ledgerhq/cryptoassets/tokens";
import { tokens as tokensByChainId } from "@ledgerhq/cryptoassets/data/evm/index";
import network from "@ledgerhq/live-network/network";
import { getEnv } from "@ledgerhq/live-env";
export const fetchERC20Tokens = (currency) => __awaiter(void 0, void 0, void 0, function* () {
    const { ethereumLikeInfo } = currency;
    const url = `${getEnv("DYNAMIC_CAL_BASE_URL")}/evm/${(ethereumLikeInfo === null || ethereumLikeInfo === void 0 ? void 0 : ethereumLikeInfo.chainId) || 0}/erc20.json`;
    const dynamicTokens = yield network({
        method: "GET",
        url,
    })
        .then(({ data }) => (data.length ? data : null))
        .catch(e => {
        log("error", "EVM Family: Couldn't fetch dynamic CAL tokens from " + url, e);
        return null;
    });
    if (dynamicTokens)
        return dynamicTokens;
    const tokens = tokensByChainId[ethereumLikeInfo === null || ethereumLikeInfo === void 0 ? void 0 : ethereumLikeInfo.chainId];
    if (tokens)
        return tokens;
    log("warning", `EVM Family: No tokens found in CAL for currency: ${currency.id}`, currency);
    return [];
});
export function preload(currency) {
    return __awaiter(this, void 0, void 0, function* () {
        const erc20 = yield fetchERC20Tokens(currency);
        // This weird thing is here to help the "clone" currencies like
        // ethereum_as_evm_test_only & polygon_as_evm_test_only
        // to get tokens despite the different currency_id
        // registered in the CAL for those chain ids
        // We should remove this after the merge
        addTokens(erc20.map(([, ...tokenRest]) => convertERC20([currency.id, ...tokenRest])));
        return erc20;
    });
}
export function hydrate(value) {
    if (!Array.isArray(value))
        return;
    addTokens(value.map(convertERC20));
    log("evm/preload", "hydrate " + value.length + " tokens");
}
//# sourceMappingURL=preload.js.map